import { useState } from 'react';
import { LoadingSpinner } from '@/shared/components/Loading';
import { useReferralAuditLog } from '@/services/referrals';
import { ReferralAuditAction } from '@/models/referral';

const ACTIONS: Array<{ value: ReferralAuditAction | ''; label: string }> = [
    { value: '', label: 'All actions' },
    { value: 'settings_updated', label: 'Settings updated' },
    { value: 'tier_overridden', label: 'Tier overridden' },
    { value: 'user_flagged', label: 'User flagged' },
    { value: 'user_unflagged', label: 'User unflagged' },
    { value: 'commission_adjusted', label: 'Commission adjusted' },
    { value: 'withdrawal_approved', label: 'Withdrawal approved' },
    { value: 'withdrawal_rejected', label: 'Withdrawal rejected' },
];

const AuditLogTab = () => {
    const [action, setAction] = useState<ReferralAuditAction | ''>('');
    const [targetUserId, setTargetUserId] = useState('');
    const { data, isLoading } = useReferralAuditLog({
        action: action || undefined,
        targetUserId: targetUserId || undefined,
        limit: 100,
    });

    if (isLoading) return <LoadingSpinner />;
    const entries = data?.data?.entries || [];

    return (
        <div>
            <div className="d-flex gap-3 align-items-center mb-3 flex-wrap">
                <select
                    className="form-select"
                    style={{ width: 220 }}
                    value={action}
                    onChange={(e) => setAction(e.target.value as ReferralAuditAction | '')}
                >
                    {ACTIONS.map((a) => (
                        <option key={a.value} value={a.value}>
                            {a.label}
                        </option>
                    ))}
                </select>
                <input
                    type="text"
                    className="form-control"
                    style={{ width: 320 }}
                    placeholder="Filter by target user id…"
                    value={targetUserId}
                    onChange={(e) => setTargetUserId(e.target.value)}
                />
                <span className="text-muted">{entries.length} entries</span>
            </div>
            <div className="table-responsive">
                <table className="table align-middle">
                    <thead>
                        <tr>
                            <th>When</th>
                            <th>Action</th>
                            <th>Admin</th>
                            <th>Target user</th>
                            <th>Reason</th>
                            <th>Before → After</th>
                        </tr>
                    </thead>
                    <tbody>
                        {entries.map((e) => (
                            <tr key={e.id}>
                                <td className="small">{new Date(e.created_at).toLocaleString()}</td>
                                <td>{e.action}</td>
                                <td className="small">
                                    <div>{e.adminEmail || e.adminId}</div>
                                </td>
                                <td className="font-monospace small">{e.targetUserId || '—'}</td>
                                <td className="small">{e.reason || '—'}</td>
                                <td>
                                    <pre className="small mb-0" style={{ maxWidth: 360, whiteSpace: 'pre-wrap' }}>
                                        {JSON.stringify({ before: e.before, after: e.after }, null, 2)}
                                    </pre>
                                </td>
                            </tr>
                        ))}
                        {entries.length === 0 && (
                            <tr>
                                <td colSpan={6} className="text-center text-muted py-4">
                                    No audit entries match this filter.
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default AuditLogTab;
